import React from 'react'
import { Layout } from './Layout'
import { useFormState } from './useFormState'

export const EditPreferences: React.FC = () => <Layout {...useFormState()} />
